/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type usePatternAutocompleteQueryVariables = {|
  pattern?: ?string,
  lang?: ?$ReadOnlyArray<?string>,
|};
export type usePatternAutocompleteQueryResponse = {|
  +elastic: ?{|
    +res: ?any
  |}
|};
export type usePatternAutocompleteQuery = {|
  variables: usePatternAutocompleteQueryVariables,
  response: usePatternAutocompleteQueryResponse,
|};
*/


/*
query usePatternAutocompleteQuery(
  $pattern: String
  $lang: [String]
) {
  elastic {
    res: autocompletion(input: {pattern: $pattern, lang: $lang})
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lang"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pattern"
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ElasticQuery",
    "kind": "LinkedField",
    "name": "elastic",
    "plural": false,
    "selections": [
      {
        "alias": "res",
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "lang",
                "variableName": "lang"
              },
              {
                "kind": "Variable",
                "name": "pattern",
                "variableName": "pattern"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "kind": "ScalarField",
        "name": "autocompletion",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "usePatternAutocompleteQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "usePatternAutocompleteQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "98a09838e5629ca39e9b92e884bfcb40",
    "id": null,
    "metadata": {},
    "name": "usePatternAutocompleteQuery",
    "operationKind": "query",
    "text": "query usePatternAutocompleteQuery(\n  $pattern: String\n  $lang: [String]\n) {\n  elastic {\n    res: autocompletion(input: {pattern: $pattern, lang: $lang})\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '84a5c22e8ef0c348f8ae9ed4efb4f01f';

module.exports = node;
